import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { ModalDialogService } from '../../services/modal-dialog/modal-dialog.service';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;
  save: () => Promise<void>;
  form: NgForm;
}

@Injectable()
export class BackSaveDiscardGuard {
  constructor(private modalDialogService: ModalDialogService) {}

  canDeactivate(
    component: CanComponentDeactivate
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (component.canDeactivate && !component.canDeactivate()) {
      this.modalDialogService.showBackSaveDiscardModal();
      return this.modalDialogService.dialogEvent$.pipe(
        map(result => {
          switch (result) {
            case 0: // Cancel
              return false;
            case 1: // Save
              Object.keys(component.form.controls).forEach(field => {
                const control = component.form.controls[field];
                control.markAsDirty({ onlySelf: true });
              });
              (component.form as any).submitted = true;
              component.form.onSubmit(result);
              // Check form validity at this point!
              component
                .save()
                .then(() => {
                  return true;
                })
                .catch(() => {
                  return false;
                });
              break;
            case 2: // No Thanks
              return true;
            default:
              return false;
          }
        }),
        first()
      );
    } else {
      return true;
    }
  }
}
